let Url_To_Array;

Url_To_Array = (() => {
    function Url_To_Array() {
        return window.location.href.split("/");
    }

    return Url_To_Array;
})();

export default Url_To_Array();
